<template>
  <el-dialog
    :visible="visible"
    title="Вход на пробный урок"
    custom-class="trail-form-modal"
    append-to-body
    @close="$emit('update:visible', false)"
  >
    <h3 class="trail-form__title">Вам будет доступно <strong>3</strong> задания</h3>
    <Divider :offset="5">
      Войти с помощью
    </Divider>
    <el-form ref="trail-form" :model="formData" :rules="rules" class="trail-form">
      <el-form-item prop="email" :error="errors.email">
        <label>
          <span>Email</span>
          <el-input v-model="formData.email" size="small" />
        </label>
      </el-form-item>
      <el-form-item class="trail-form__actions">
        <el-button type="success" size="small" @click="submit">
          Войти
        </el-button>
      </el-form-item>
    </el-form>
    <Divider>
      или
    </Divider>
    <SocialButtons />
  </el-dialog>
</template>

<script>
import Divider from '@/components/Common/Divider'
import SocialButtons from '@/components/Auth/SocialButtons'

export default {
  name: 'ModalTrialLesson',
  components: { Divider, SocialButtons },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    formData: {
      email: ''
    },

    errors: {
      email: ''
    },

    rules: {}
  }),

  methods: {
    submit() {
      this.$emit('update:visible', false)
      this.$router.push({ name: 'trial-lessons' })
    }
  }
}
</script>

<style scoped lang="scss">
.trail-form {
  margin: 24px 36px 0;

  @include md-and-down {
    margin: 0;
  }

  &__title {
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    letter-spacing: 0.35px;
    font-family: 'PFCentroSansPro', sans-serif;
    color: $deepdark;
    font-weight: normal;
    margin-bottom: 48px;

    @include md-and-down {
      font-size: 19px;
      line-height: 23px;
      margin-bottom: 24px;
    }

    strong {
      font-weight: bold;
      color: $luchmara;
    }
  }

  &__actions {
    &::v-deep .el-form-item__content {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &:after,
      &:before {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
.trail-form-modal {
  width: 498px !important;

  @include sm-and-down {
    width: 100% !important;
  }
}
</style>
